import React from "react";
import styled from "styled-components";
import ItemMenu from "./components/ItemMenu";
import {Link} from "react-router-dom";

export default function Menu({base, logoInvert}) {
   return (
      <MenuContent>
         <ul>
            <Link className="logo" to="/">
               {!logoInvert ? (
                  <img src={require("../../assets/logo/domecq_academy_white.png")} alt="domecq" width="100%" />
               ) : (
                  <img src={require("../../assets/logo/domecq_academy.png")} alt="domecq" width="100%" />
               )}
            </Link>
            <ItemMenu base={base} path="/cursos_esenciales" name="cursos esenciales" />
            <ItemMenu base={base} path="/certificado_prime" name="certificado prime" />
            <ItemMenu base={base} path="/programa_emblem" name="programa emblem" />
            <ItemMenu base={base} path="/programa_enterprise" name="programa enterprise" />
            <ItemMenu base={base} path="/domecq_academy" name="domecq academy" />
            <ItemMenu base={base} path="/facilitadores" name="facilitadores" />
         </ul>
      </MenuContent>
   );
}

export const MenuContent = styled.div`
   widht: 100%;
   padding: 1em 0;
   padding-top: 0;
   margin-top: 0.3em;

   & .logo {
      width: 100px;
      width: 135px;
      display: block;

      & img {
         margin-bottom: -6px;
      }
   }

   & ul {
      display: flex;
      justify-content: space-between;
      align-items: baseline;
      li {
         :last-child {
            padding-right: 0;
         }
      }
   }

   @media screen and (max-width: 1600px) {
      & .logo {
         width: 110px;
         & img {
            margin-bottom: -7px;
         }
      }
   }

   @media screen and (max-width: 1400px) {
      & .logo {
         width: 100px;
         & img {
            margin-bottom: -7px;
         }
      }
   }

   @media screen and (max-width: 800px) {
      & .logo {
         width: 70px;

         & img {
            margin-bottom: -4px;
         }
      }
   }
`;
